import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { BuildBeamLogo } from '../components/ui/BrandLogo';
import { 
  FiGrid, FiCheckSquare, FiUsers, FiTruck, 
  FiFileText, FiShield, FiBarChart2, FiPlayCircle 
} from 'react-icons/fi';

const NAV_ITEMS = [
  { path: '/', label: 'Dashboard', icon: FiGrid },
  { path: '/demo', label: 'System Demo', icon: FiPlayCircle },
  { path: '/tasks', label: 'Site Tasks', icon: FiCheckSquare },
  { path: '/rfis', label: 'RFI Tracker', icon: FiFileText },
  { path: '/deliveries', label: 'Material Logic', icon: FiTruck },
  { path: '/subcontractors', label: 'Sub Board', icon: FiUsers },
  { path: '/safety', label: 'Safety Cmd', icon: FiShield },
  { path: '/reports', label: 'Progress Ops', icon: FiBarChart2 },
];

export const Sidebar = () => {
  return (
    <aside className="w-64 border-r border-slate-800/80 bg-slate-950/95 backdrop-blur-xl flex flex-col h-full z-30">
      <div className="h-20 flex items-center px-6 border-b border-slate-800/80">
        <BuildBeamLogo size="sm" />
      </div>

      <nav className="flex-1 py-6 px-3 space-y-1 overflow-y-auto custom-scrollbar">
        <div className="px-3 mb-4 text-[10px] font-mono text-slate-500 uppercase tracking-[0.25em]">Sectors & Control</div>
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `
              flex items-center gap-3 px-3 py-3 rounded-sm transition-all duration-300 group relative
              ${isActive 
                ? 'text-cyan-400 bg-cyan-950/20' 
                : 'text-slate-500 hover:text-slate-200 hover:bg-slate-900/50'
              }
            `}
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <motion.div 
                    layoutId="activeNav"
                    className="absolute left-0 top-0 bottom-0 w-0.5 bg-cyan-400 shadow-[0_0_10px_rgba(6,182,212,0.8)]"
                  />
                )}
                <SafeIcon icon={item.icon} className={`text-lg transition-colors ${isActive ? 'text-cyan-400' : 'text-slate-600 group-hover:text-cyan-500'}`} />
                <span className="text-xs font-bold tracking-wide uppercase">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-800/80 bg-slate-900/30">
        <div className="flex items-center justify-between text-[10px] font-mono text-slate-600 mb-2">
          <span>Telemetry Link</span>
          <span className="text-emerald-500 flex items-center gap-1">
            <span className="w-1 h-1 bg-emerald-500 rounded-full animate-pulse"></span>
            Stable
          </span>
        </div>
        <div className="w-full bg-slate-800 h-1 rounded-full overflow-hidden">
          <div className="bg-cyan-500 h-full w-[92%]"></div>
        </div>
      </div>
    </aside>
  );
};